/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import OzModalButton from './partials/OzModalButton';
import SimpleEscapeForm from './partials/SimpleEscapeForm';
import EmailPlayerForm from './partials/EmailPlayerForm';
import RoomLeaderboard from './partials/RoomLeaderboard';
import './Escape.css';
import {
  getEscape,
  getRankEscape,
  listTeams,
  fetchUser,
  updateEscape,
  emailPlayer,
} from '../actions';


class Escape extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['escape', getEscape, p => p.id],
    ['rankEscape', getRankEscape, p => { return [null, {}, { escape: p.id }] }],
    ['teams', listTeams, p => { return [{ escape: p.id }] }],
  ]

  state = {};

  showEdit() {
    this.setState({
      editing: true,
    });
  }

  closeEdit() {
    this.setState({
      editing: false,
    });
  }

  emailPlayer(e, values) {
    console.log('email player values:', values);
    this.props.emailPlayer(values)
      .then(resp => {
        if (resp.error) return;
        alert('Success!');
        this.setState({ emailing: false });
      });
  }

  renderEscape() {
    let escape = this.props.escape;
    let rank = this.props.rankEscape;
    if (!escape) return;

    let date;
    if (escape.date) {
      date = moment(escape.date, 'YYYY-MM-DD');
    }
    let img = escape.photo || 'https://escapespy.s3-us-west-2.amazonaws.com/misc/default.png';

    let outcome;
    if (escape.didEscape) {
      outcome = 'Escaped!';
    } else {
      outcome = 'Did not escape...';
    }

    let playersNode;
    if (escape.team) {
      // playersNode = (
      //   <div><b>Team:</b> {escape.team.name}</div>
      // );
    } else {
      playersNode = (
        <div><b>Player:</b> {escape.username}</div>
      );
    }

    let teamNode;
    if (escape.team) {
      let teams = this.props.teams;
      if (teams && teams.count > 0) {
        let team = teams.items[0];

        let nodes = team.members.map(member => {
          return (
            <div className="member">
              {member.username}
            </div>
          );
        });

        teamNode = (
          <div className="team">
            <div className="team-header"><b>{team.name}</b></div>
            <div className="members">{nodes}</div>
          </div>
        );
      }
    }

    let rankNum = rank && rank.rank;

    let editImageNode;
    if (escape.canEdit) {
      if (escape.photo) {
        editImageNode = (
          <div className="edit-image">
            <Button onClick={() => this.showEdit()}>Change Photo</Button>
          </div>
        );
      } else {
        editImageNode = (
          <div className="edit-image empty">
            <Button bsStyle="primary" bsSize="lg" onClick={() => this.showEdit()}>Add Escape Photo</Button>
          </div>
        );
      }
    }

    return (
      <div className="escape">
        <div className="info">
          <div className={cx('outcome-time', { 'no-time': !escape.time })}>
            {escape.time && <div className="time">{escape.prettyTime}</div>}
            <div className="outcome">{outcome}</div>
          </div>
          <div className="details">
            {playersNode}
            <div><b>Room:</b> {escape.room.name}</div>
            {date && <div className="date"><b>Date:</b> {date.format('MMMM Do, YYYY')}</div>}
            {teamNode}
            {/*rankNum && <div><b>Rank:</b> #{rankNum} fastest on EscapeSpy</div>*/}
          </div>
        </div>
        <div className="image">
          {editImageNode}
          <img src={img} />
        </div>
      </div>
    );
  }

  save(e, values) {
    console.log('SAVE ESCAPE', values);
    this.props.updateEscape(this.props.escape.id, values)
      .then(resp => {
        if (resp.error) return;
        this.closeEdit();
      });
  }

  verify() {
    this.props.updateEscape(this.props.escape.id, { verified: true });
  }

  unverify() {
    this.props.updateEscape(this.props.escape.id, { verified: false });
  }

  renderEdit() {
    return (
      <Modal show={this.state.editing}>
        <Modal.Header closeButton onHide={() => this.closeEdit()}>Edit Escape</Modal.Header>
        <SimpleEscapeForm
          values={this.props.escape}
          modal={true}
          errors={this.props.errors.escape}
          buttonText="Save"
          cancelText="Cancel"
          onSubmit={(e, values) => this.save(e, values)}
          onCancel={() => this.closeEdit()}
        />
      </Modal>
    )
  }

  renderControls() {
    let escape = this.props.escape;
    if (!escape) return;
    if (!escape.canVerify) return;

    return (
      <div className="controls">
        <div className="message">
          <div className="owner-message"><b>Owner control area.</b> Only room owner (you!) can see this.</div>
          <div>
            <p>Use the controls here to verify escapes. You can also adjust the time and outcome, and add the team's photo if you have it.</p>
          </div>
        </div>
        <div className="buttons">
          <Button onClick={() => this.showEdit()}>Edit</Button>{' '}
          {!escape.verified && <Button bsStyle="primary" onClick={() => this.verify()}>
           <FontAwesome name="check-circle" />{' '}
           Verify
           </Button>}
           {escape.verified && <Button onClick={() => this.unverify()}>
            Un-Verify
            </Button>}{' '}
            {escape.verified &&
             <OzModalButton
             modalTitle="Email Player"
             show={this.state.emailing}
             onShow={() => this.setState({ emailing: true })}
             onHide={() => this.setState({ emailing: false })}
             >
             <Button bsStyle="primary">
             <FontAwesome name="paper-plane" /> Email to Player
             </Button>

             <EmailPlayerForm
             modal={true}
             values={{
               escapeId: this.props.escape.id,
               members: [{ email: this.props.escape.email, name: this.props.escape.username }],
             }}
             errors={this.props.errors.emailPlayer}
             onCancel={() => this.setState({ emailing: false })}
             onSubmit={(e, values) => this.emailPlayer(e, values)}
             buttonText="Send Email"
             cancelText="Cancel"
             />
             </OzModalButton>}
        </div>
      </div>
    );
  }

  render() {
    let title;
    let escape = this.props.escape;
    if (escape) {
      let name;
      if (escape.team) {
        name = escape.team.name + "'s";
      } else {
        name = escape.username + "'s";
      }
      title = <span className="title"><b>{name}</b> escape from <b>{escape.room.name}</b></span>;
    }

    return (
      <Wrapper className="EscapeComponent" padded title={title}>
        {this.renderControls()}
        {this.renderEdit()}
        {this.renderEscape()}
        {/*escape && <RoomLeaderboard roomId={escape.room.id} escapeId={escape.id} />*/}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    escape: state.get.escape,
    teams: state.list.team,
    rankEscape: state.get.rankEscape,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    fetchUser,
    updateEscape,
    emailPlayer,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Escape);



/** WEBPACK FOOTER **
 ** ./src/components/Escape.js
 **/